import { sendEventToJumbo } from './jumbo';

export const TIMELINE_EVENTS = {
  GET_TIMELINE_DETAILS_SUCCESS: 'get_timeline_details_success',
  GET_TIMELINE_DETAILS_FAILURE: 'get_timeline_details_failure',
  TIMELINE_DETAILS_START_POLLING_EVENT: 'timeline_details_start_polling_event',
  TIMELINE_DETAILS_STOP_POLLING_EVENT: 'timeline_details_stop_polling_event',
  TIMELINE_BATCHED_DETAILS_MODAL_OPEN: 'timeline_batched_details_modal_open',
  TIMELINE_BATCHED_DETAILS_MODAL_CLOSE: 'timeline_batched_details_modal_close',
  CRYSTAL_VIEW_MODAL_OPEN: 'crystal_view_modal_open',
  CRYSTAL_VIEW_MODAL_CLOSE: 'crystal_view_modal_close',
  TIMELINE_DELAY_SUMMARY_MODAL_OPEN: 'timeline_delay_summary_modal_open',
  TIMELINE_DELAY_SUMMARY_MODAL_CLOSE: 'timeline_delay_summary_modal_close',
};

export const sendTimelineApiEvents = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
  });
};

export const sendTimelineModalEvents = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
  });
};
